/* eslint-disable */
import React, { useContext } from "react";
import { Data, Filters } from './contexts';
import { parseMoney } from '../utils';
import { pnlRows } from './NAICSFocusedReport/NAICSFocusedReport';
import { CommonSizeArrows } from './report_components/MoneyHelpers';
import { CheckMark, XMark } from '../utils/SVGIcons';

const MonthlyKPITable = (props) => {
    const { monthly_calcs, trailing12 } = useContext(Data);
    const { filters } = useContext(Filters);
    const finalFilters = props.tabFilters || filters;
    const compareWith = finalFilters.compare_with;
    const filterYear = finalFilters.year
    const previousYear = filterYear - 1
    const monthlyCalcs = finalFilters.report_period === 'Trailing 12' ? trailing12 : monthly_calcs;
    const avgCalcs = props.aggregateData && finalFilters.report_period === 'Trailing 12' ? props.aggregateData?.trailing12?.avg : props.aggregateData ? props.aggregateData?.monthly?.avg : monthlyCalcs?.avg;
    const docsAvgCalcs = props.aggregateData && finalFilters.report_period === 'Trailing 12' ? props.aggregateData?.trailing12?.docs_avg : props.aggregateData ? props.aggregateData?.monthly?.docs_avg : monthlyCalcs?.docs_avg;
    let compareTitle = 'Peers Avg'

    if ((compareWith === 'YOY' && finalFilters.report_period !== 'Trailing 12') || (compareWith === 'Default:YOY' && finalFilters.report_period !== 'Trailing 12')) {
        let YOYyearDisplay = props.calendarYearEnd ? previousYear : filterYear
        compareTitle = `YOY ${YOYyearDisplay}`
    } else if (compareWith && compareWith.includes('Forecast')) {
        compareTitle = props.forecastName
    } else if (finalFilters.report_period === 'Trailing 12' && compareWith !== 'Default:None') {
        compareTitle = `T12 ${previousYear}`
    } else if (compareWith === 'Default:None') {
        compareWith = ''
    }

    const forecastYear = Object.keys(props.forecastVals || {}).length > 0 ? Object.keys(props.forecastVals['total_revenue'])[0] : null
    const doctorsNAICS = ['621', '6211', '6213'];
    const monthsObj = {
        1: 'Jan',
        2: 'Feb',
        3: 'Mar',
        4: 'Apr',
        5: 'May',
        6: 'Jun',
        7: 'Jul',
        8: 'Aug',
        9: 'Sep',
        10: 'Oct',
        11: 'Nov',
        12: 'Dec'
    }

    const monthlyKPITable = () => {
        const rowMetrics = [
            {
                letter: 'A',
                color: 'light-blue',
                copy: 'INCOME',
                header: true,
                children: [
                    {
                        copy: 'Total Revenue',
                        key: 'total_revenue',
                        format: 'money'
                    }
                ],
            },
            {
                letter: 'B',
                color: 'light-green',
                copy: 'LAB & SUPPLIES',
                header: true,
                children: [
                    {
                        copy: 'Laboratory Fees',
                        key: 'laboratory_fees',
                        asterisk: true,
                        format: 'percentOfRevenue'
                    }
                ],
            },
            {
                letter: 'C',
                color: 'light-orange',
                copy: 'PAYROLL EXPENSE',
                header: true,
                children: [
                    {
                        copy: 'Salaries - Office',
                        key: 'office',
                        focus: 'dental',
                        asterisk: true,
                        format: 'percentOfRevenue'
                    },
                    {
                        copy: 'Salaries - Hygiene',
                        key: 'hygienist',
                        focus: 'dental',
                        asterisk: true,
                        format: 'percentOfRevenue'
                    },
                    {
                        copy: 'Salaries - Chairside/Other',
                        key: 'assistant',
                        focus: 'dental',
                        asterisk: true,
                        format: 'percentOfRevenue'
                    },
                    {
                        copy: 'Salaries - Office',
                        key: 'total_compensation_office',
                        focus: 'doctor',
                        asterisk: true,
                        format: 'percentOfRevenue'
                    },
                    {
                        copy: 'Salaries - Nurse',
                        key: 'total_compensation_nurse',
                        focus: 'doctor',
                        asterisk: true,
                        format: 'percentOfRevenue'
                    },
                    {
                        copy: 'Salaries - Other',
                        key: 'total_compensation_assistant',
                        focus: 'doctor',
                        asterisk: true,
                        format: 'percentOfRevenue'
                    }
                ],
            },
            {
                letter: 'D',
                color: 'purple',
                copy: 'DOCTOR PAY (W2)',
                header: true,
                children: [
                    {
                        copy: 'Dentist',
                        key: 'dentist',
                        focus: 'dental',
                        asterisk: true,
                        format: 'percentOfRevenue'
                    },
                    {
                        copy: 'Doctor',
                        key: 'total_compensation_doctor',
                        focus: 'doctor',
                        asterisk: true,
                        format: 'percentOfRevenue'
                    }
                ],
            },
            {
                letter: 'E',
                color: 'apple-red',
                copy: 'OVERHEAD COSTS',
                header: true,
                children: [
                    {
                        copy: 'Total Fixed Expenses',
                        key: 'total_administrative_costs',
                        asterisk: true,
                        format: 'percentOfRevenue'
                    }
                ],
            },
            {
                letter: 'F',
                color: 'lemon-yellow',
                copy: 'MARKETING',
                header: true,
                children: [
                    {
                        copy: 'Sales & Marketing',
                        key: 'total_customer_costs_sales_& marketing',
                        asterisk: true,
                        format: 'percentOfRevenue'
                    }
                ],
            },
            {
                letter: 'G',
                color: 'navy-blue',
                copy: 'RENT',
                header: true,
                children: [
                    {
                        copy: 'Rent & Facilities Costs',
                        key: 'rent_and_facilities_costs',
                        asterisk: true,
                        format: 'percentOfRevenue'
                    }
                ],
            },
            {
                letter: 'H',
                color: 'grass-green',
                copy: 'EBITDA',
                header: true,
                children: [
                    {
                        copy: 'EBITDA',
                        key: 'ebitda',
                        format: 'percentOfRevenue'
                    },
                    {
                        copy: 'EBITDA Dollar Figure',
                        key: 'ebitda',
                        format: 'money'
                    }
                ],
            },
            {
                letter: 'I',
                color: 'violet',
                copy: 'DOCTOR MARGIN',
                header: true,
                children: [
                    {
                        copy: 'Net Income (Before Non-Operating & Doctor Costs)',
                        key: 'operating_expenses_net_income',
                        format: 'percentOfRevenue'
                    }
                ],
            },
        ]

        const mappedTotal = (annualOrMonthly, row, youCalcs, compareCalcs, key, month = 1, year = null) => {
            let totalObj = {}
            totalObj['key'] = key

            let youSum = 0;
            let compareSum = 0

            if (key === 'salaries_non_owners') {
                let youTotalCompensation = youCalcs?.['total_compensation']?.[year]?.[month] || 0;
                let compareTotalCompensation = compareCalcs?.['total_compensation']?.[year]?.[month] || 0;
                let youSalariesDoctor = 0
                let compareSalariesDoctor = 0

                if (props.naicsCode && props.naicsCode.startsWith('6212')) {
                    youSalariesDoctor = youCalcs?.['dentist']?.[year]?.[month] || 0;
                    compareSalariesDoctor = compareCalcs?.['dentist']?.[year]?.[month] || 0;
                } else if (props.naicsCode && doctorsNAICS.some(naics => props.naicsCode.startsWith(naics))) {
                    youSalariesDoctor = youCalcs?.['total_compensation_doctor']?.[year]?.[month] || 0;
                    compareSalariesDoctor = compareCalcs?.['total_compensation_doctor']?.[year]?.[month] || 0;
                }

                youSum = youTotalCompensation - youSalariesDoctor
                compareSum = compareTotalCompensation - compareSalariesDoctor
            } else {
                row.map_keys.forEach((c) => {
                    youSum += youCalcs?.[c]?.[year]?.[month] || 0;
                    compareSum += compareCalcs?.[c]?.[year]?.[month] || 0;
                })
            }

            totalObj['youVal'] = youSum
            totalObj['compareVal'] = compareSum
            return totalObj
        }

        const totalNAICSFocused = (annualOrMonthly, rows, youCalcs, compareCalcs, key, month = 1, year = null) => {
            let childrenObjs = rows.filter(r => r.parentKey === key)
            let totalObj = {}
            let childrenValues = []
            childrenObjs.forEach((c) => {
                childrenValues.push(mappedTotal(annualOrMonthly, c, youCalcs, compareCalcs, c.key, month, year))
            })


            let youTotalRevenue = youCalcs?.['total_revenue']?.[year]?.[month] || 0;
            let compareTotalRevenue = compareCalcs?.['total_revenue']?.[year]?.[month] || 0
            let youSum = 0;
            let compareSum = 0
            childrenValues.forEach((c) => {
                youSum += c['youVal'] ? c['youVal'] : 0
                compareSum += c['compareVal'] ? c['compareVal'] : 0
            })

            totalObj['youSum'] = youSum
            totalObj['youVal'] = (youSum / youTotalRevenue) * 100;
            totalObj['compareSum'] = compareSum
            totalObj['compareVal'] = (compareSum / compareTotalRevenue) * 100;
            totalObj['deltaVal'] = totalObj['youVal'] - totalObj['compareVal']
            return totalObj
        }

        let totalRevenue = Object.values(monthlyCalcs?.you?.total_revenue?.[filterYear] || {})
        let currentMonth = totalRevenue && totalRevenue.indexOf(null) !== -1 ? totalRevenue.indexOf(null) : 12;
        const buildRows = () => {
            if (totalRevenue.length > 0) {
                let year = filterYear
                let youRevenue = totalRevenue?.[currentMonth - 1]
                let compareRevenue = avgCalcs?.total_revenue?.[year]?.[currentMonth]
                let youCalcs = monthlyCalcs?.you
                let compareCalcs = avgCalcs
                let doctorCompareCalcs = docsAvgCalcs
                let allRows = []
                let naicsFocus = props.naicsCode.startsWith('6212') ? 'dental' : 'doctor'
                let doctorPNLRows = pnlRows(props.naicsCode)

                rowMetrics.forEach(row => {
                    allRows.push(row)
                    row.children.forEach(child => {
                        if ((child.focus && child.focus === naicsFocus) || !child.focus) {
                            if (child.format === 'money') {
                                child.youVal = youCalcs?.[child.key] ? youCalcs?.[child.key]?.[year]?.[currentMonth] : 0
                                child.compareVal = compareCalcs?.[child.key] ? compareCalcs?.[child.key]?.[year]?.[currentMonth] : 0
                                child.deltaVal = ((child.youVal - child.compareVal) / child.compareVal) * 100
                                child.status = CommonSizeArrows(child.deltaVal, 0, child.key)
                                child.arrow = 'goodUp'
                            }

                            if (child.format === 'percentOfRevenue') {
                                if (child.key === 'total_administrative_costs' && doctorPNLRows) {
                                    let rowObj = totalNAICSFocused('monthly', doctorPNLRows, youCalcs, doctorCompareCalcs, 'total_administrative_costs', currentMonth, year)
                                    child.arrow = child.key !== 'ebitda' ? 'goodDown' : 'goodUp'
                                    child = { ...child, ...rowObj }
                                } else if (child.key === 'operating_expenses_net_income' && doctorPNLRows) {
                                    let totalDirectCosts = totalNAICSFocused('monthly', doctorPNLRows, youCalcs, doctorCompareCalcs, 'total_direct_costs', currentMonth, year)
                                    let totalAdminCosts = totalNAICSFocused('monthly', doctorPNLRows, youCalcs, doctorCompareCalcs, 'total_administrative_costs', currentMonth, year)
                                    compareRevenue = doctorCompareCalcs?.total_revenue?.[year]?.[currentMonth]

                                    child.youVal = ((youRevenue - totalDirectCosts['youSum'] - totalAdminCosts['youSum']) / youRevenue) * 100
                                    child.compareVal = ((compareRevenue - totalDirectCosts['compareSum'] - totalAdminCosts['compareSum']) / compareRevenue) * 100
                                    child.deltaVal = child.youVal - child.compareVal
                                    child.arrow = 'goodUp'
                                } else {
                                    let youVal = monthly_calcs?.you?.[child.key] ? monthly_calcs?.you?.[child.key]?.[year]?.[currentMonth] : 0
                                    let compareVal = compareCalcs?.[child.key] ? compareCalcs?.[child.key]?.[year]?.[currentMonth] : 0

                                    if (['office', 'hygienist', 'assistant', 'total_compensation_office', 'total_compensation_nurse', 'total_compensation_assistant', 'dentist', 'doctor'].includes(child.key)) {
                                        compareVal = doctorCompareCalcs?.[child.key] ? doctorCompareCalcs?.[child.key]?.[year]?.[currentMonth] : 0
                                        compareRevenue = doctorCompareCalcs?.total_revenue?.[year]?.[currentMonth]
                                    }
                                    child.youVal = (youVal / youRevenue) * 100
                                    child.compareVal = (compareVal / compareRevenue) * 100
                                    child.deltaVal = child.youVal - child.compareVal
                                    child.arrow = child.key !== 'ebitda' ? 'goodDown' : 'goodUp'
                                }
                                child.status = CommonSizeArrows(child.youVal, child.compareVal, child.key)
                            }
                            allRows.push(child)
                        }
                    })
                })

                return (
                    allRows.map((row, i) => {
                        let you, compare, delta = ''
                        if (row.format === 'money') {
                            you = parseMoney(row.youVal)
                            compare = parseMoney(row.compareVal)
                            delta = row.deltaVal.toFixed(2) + '%'
                        } else if (row.format === 'percentOfRevenue') {
                            you = row.youVal.toFixed(2) + '%'
                            compare = row.compareVal.toFixed(2) + '%'
                            delta = row.deltaVal.toFixed(2) + '%'
                        }

                        let checkOrX = ['best', 'better'].includes(row.status) ? <div className='good-check'><CheckMark /></div> : ['maintain'].includes(row.status) ? null : <div className='bad-x'><XMark /></div>
                        let finalDelta = ''

                        if (['best', 'better'].includes(row.status) && row.arrow === 'goodUp') {
                            finalDelta = <div className='kpi-arrow good-arrow'>&#9650;</div>
                        } else if (['worst', 'worse',].includes(row.status) && row.arrow === 'goodUp') {
                            finalDelta = <div className='kpi-arrow bad-arrow'>&#9660;</div>
                        } else if ('maintain' === row.status && row.arrow === 'goodUp' && row.deltaVal > 0) {
                            finalDelta = <div className='kpi-arrow good-arrow'>&#9650;</div>
                        } else if ('maintain' === row.status && row.arrow === 'goodUp' && row.deltaVal < 0) {
                            finalDelta = <div className='kpi-arrow bad-arrow'>&#9660;</div>
                        } else if (['best', 'better'].includes(row.status) && row.arrow === 'goodDown') {
                            finalDelta = <div className='kpi-arrow good-arrow'>&#9660;</div>
                        } else if (['worst', 'worse'].includes(row.status) && row.arrow === 'goodDown') {
                            finalDelta = <div className='kpi-arrow bad-arrow'>&#9650;</div>
                        } else if ('maintain' === row.status && row.arrow === 'goodDown' && row.deltaVal < 0) {
                            finalDelta = <div className='kpi-arrow good-arrow'>&#9660;</div>
                        } else if ('maintain' === row.status && row.arrow === 'goodDown' && row.deltaVal > 0) {
                            finalDelta = <div className='kpi-arrow bad-arrow'>&#9650;</div>
                        }
                        let headerStyles = row.color ? row.color + ' kpi-letter-box' : ''


                        if (row.copy === 'INCOME') {
                            let monthText = monthsObj?.[currentMonth]?.toUpperCase() + ' ' + String(filterYear)
                            return (
                                <tr key={`monthly-kpi-${i}`} className='kpi-header-row'>
                                    <td className='kpi-header-cell'><div className='kpi-header-title'><div className={headerStyles}>{row.letter}</div><span className='kpi-header-title-metric'>{row.copy}</span></div></td>
                                    <td className='kpi-bold kpi-normal-left-border-cell'></td>
                                    <td colSpan='2'></td>
                                    <td className='kpi-bold kpi-normal-right-border-cell'></td>
                                </tr>
                            )
                        } else if (row.header) {
                            return (
                                <tr key={`monthly-kpi-${i}`} className='kpi-header-row'>
                                    <td className='kpi-header-cell'><div className='kpi-header-title'><div className={headerStyles}>{row.letter}</div><span className='kpi-header-title-metric'>{row.copy}</span></div></td>
                                    <td className='kpi-normal-left-border-cell'></td>
                                    <td className='kpi-normal-cell'></td>
                                    <td className='kpi-checkorx-cell'></td>
                                    <td className='kpi-normal-right-border-cell'></td>
                                </tr>
                            )
                        } else {
                            return (
                                <tr key={`monthly-kpi-${i}`} className='kpi-normal-row'>
                                    <td className='kpi-header-cell'><span className='kpi-copy-cell'>{row.copy}</span>{row.asterisk ? <span>&#42;</span> : null}</td>
                                    <td className='kpi-normal-left-border-cell'>{you}</td>
                                    <td className='kpi-normal-cell'>{compare}</td>
                                    <td className='kpi-checkorx-cell'>{checkOrX}</td>
                                    <td className='kpi-normal-right-border-cell'><div className='vs-target-container'>{finalDelta} <div className='kpi-delta-val'>{delta}</div><div className='kpi-arrow'></div></div></td>
                                </tr>
                            )
                        }
                    })
                )
            } else {
                return <tr  key={`monthly-kpi-normal-row`} className='kpi-normal-row'><td><div>You must have Monthly data available to view this page.</div></td></tr>
            }
        }

        let monthText = currentMonth ? monthsObj?.[currentMonth]?.toUpperCase() + ' ' + String(filterYear) : 'You'
        return (
            <div>
                <table className='kpi-results-table'>
                    <thead>
                        <tr>
                            <td></td>
                            <td className='kpi-normal-left-border-cell'>{monthText}</td>
                            <td className='kpi-normal-cell' colSpan='2'>{compareTitle}</td>
                            <td className='kpi-normal-right-border-cell'>Δ Delta</td>
                        </tr>
                    </thead>
                    <tbody>
                        {buildRows()}
                    </tbody>
                </table>
                <div className='asterisk-note'>&#42; For this metric, a result below target is favorable</div>
            </div>
        )
    }

    return (
        <div className='custom-report-pdf-portrait'>
            <h1 className='analysis-page-title'>KPI Results - Monthly Analysis</h1>
            <div>
                {monthlyKPITable()}
            </div>
        </div>
    )
}

export default MonthlyKPITable;